import { authenticatedPost } from '../../../../../../api/request';

export default async function createEducation(idDoctorUser, experienceBody, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando una entrada de educación.');
    const url = `/doctor-profile-management/education/${idDoctorUser}`;
    return await authenticatedPost(url, onFail, experienceBody);
}
